<template>
  <div>
    <section class="section" v-if="stepNext == 1">
        <div class="container" style="padding:15px;width:55%;min-width:400px;margin-left:auto;margin-right:auto;text-align:left">
            <h1 class="title is-2">Thank you. You have successfully activated your Connected Supplier Membership.</h1>
            <a class="button is-warning payment__button" @click.prevent="stepNext=0">Back</a>
        </div>
    </section>
    <section class="payment section" v-else-if="addcard === true">
        <div class="container">
            <h1 class="title page-title has-padding-v-50 is-4 has-text-centered">Add new payment method</h1>
            <div class="payment__form container">
                <!-- Card Details Form -->
                <div class="form-card">
                    <form action="http://127.0.0.1/charge" method="post" id="payment-form" >
                        <div class="form-row">
                           <div id="card-element">
                              <div class="field">
                                  <span class="brand"><i class="pf pf-credit-card" id="brand-icon"></i></span>
                                  <div id="card-element-card-number"></div>
                                  <label for="card-element-card-number">Card Number</label>
                              </div>
                              <div class="field half-width">
                                  <div id="card-element-card-expiry"></div>
                                  <label for="card-element-card-expiry">Expiration Date</label>
                              </div>
                              <div class="field half-width card-cvc">
                                  <div id="card-element-card-cvc"></div>
                                  <label for="card-element-card-cvc">CVC Code</label>
                              </div>
                           </div>
                        </div>
                    </form>
                </div>
                <div>
                  <a class="button btn-next payment__button" @click.prevent="sendCard" :disabled="stripeLoaded === false">Insert</a>
                  <a class="button is-text payment__button has-margin-v-10" @click.prevent="cancel">Cancel</a>
                </div>
            </div>
        </div>
    </section>
    <section class="payment section" v-else>
      <div class="container">
        <h1 class="title page-title has-padding-v-50 is-4 has-text-centered">Payment Methods</h1>
        <div class="payment__text">
            <p>
              Manage your payment methods on this page.
            </p>
        </div>

        <div class="payment__form container">
            <div id="card-errors" role="alert">
             <span v-if="errorcard.error === true" class="is-danger" v-html="errorcard.msg"></span>
             <span v-else class="text-success" v-html="errorcard.msg"></span>
            </div>
            <a class="button is-success payment__button" @click.prevent="addnewCard">New Payment method</a>
            <a v-if="hascard" class="button is-danger payment__button" @click.prevent="reset">Reset payment methods</a>
        </div>

        <div v-if="cards && cards.cards && cards.cards.length">
          <div class="mdc-layout-grid__inner" v-for="card in cards.cards">
            <div class="">{{ card.email }}</div>
            <div class="">
              <span>Exp. Date  {{ card.exp_month }}/{{ card.exp_year }}</span>
            </div>
            <div class="font-smaller">
              <i class="pf pf-visa" v-if="card.brand.toLowerCase() == 'visa'"></i>
              <i class="pf pf-mastercard" v-if="card.brand.toLowerCase() == 'mastercard'"></i>
              <i class="pf pf-american-express" v-if="card.brand.toLowerCase() == 'american express'"></i>
              <i class="pf pf-diners" v-if="card.brand.toLowerCase() == 'diners club'"></i>
              <i class="pf pf-discover" v-if="card.brand.toLowerCase() == 'discover'"></i>
              <i class="pf pf-jcb" v-if="card.brand.toLowerCase() == 'jcb'"></i>
              <i class="pf pf-unionpay" v-if="card.brand.toLowerCase() == 'union-pay'"></i>
              <i class="pf pf-credit-card" v-if="card.brand.toLowerCase() == 'unknown' || card.brand == ''"></i>
               **** {{ card.last4 }}
            </div>
            <div class="font-smaller">
              <i class="ico ico-attention" v-if="card.cvc_check !== 'pass'"></i>
              <i class="ico ico-checkmark" v-else></i>
            </div>
          </div>
        </div>
        <div v-else>
          <p>No payment methods set yet.</p>
        </div>
      </div>
    </section>
    <b-loading :is-full-page="true" :active="isLoading"></b-loading>
  </div>
</template>

<script>
import api from '../libs/api';

var cardNumber, cardExpiry, cardCvc, stripe, elements;
export default {
  name: 'activate',
  data() {
    return {
      supplier: {},
      stepNext: 0,
      isLoading: true,
      manualCharge: false,
      addcard: false,
      errorcard: "",
      cards: [],
      cardinfo: {},
      default_card: "",
      hascard: false,
      loadingcard: false,
      paymentMethodDialog: false,
      isPayPal: false,
      stripeLoaded: true
    }
  },
  created: async function() {
		const that = this;
    await this.loadData();
    setTimeout(function() {
      stripe = Stripe(process.env.VUE_APP_STRIPE);
      elements = stripe.elements();
      that.isLoading = false;
      if (!that.hascard) {
        that.addnewCard();
      }
    },1000);
  },
	async mounted() {
    const script = document.createElement('script');
    script.src = "https://js.stripe.com/v3/";
    document.head.appendChild(script);
  },
  methods: {
    async loadData() {
      let that = this;
      this.supplier = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/info',
        method: 'GET',
      });

      if (this.supplier.paid == true || this.supplier.primary === true) {
        const getinfo = await api({endpoint: `${process.env.VUE_APP_API}/payments`, path: '/', method: 'GET'});
        if (getinfo.cards && getinfo.cards.cards && getinfo.cards.cards.length !== 0) {
    		  this.hascard = true;
          this.cardinfo = getinfo;
          this.cards = getinfo.cards;
    		}
      }
    },
    cancel() {
      this.addcard = false;
    },
    addnewCard() {
      const that = this;
      this.addcard = true;
      this.stripeLoaded = false;
      setTimeout(function() {
        that.setupCard();
      },600);
    },
    setupCard() {
			var style = {
				base: {
					color: '#424F65',
					lineHeight: '18px',
					fontFamily: '"Muli", sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '16px',
					'::placeholder': {
						color: '#D1D1D1',
					},
					':-webkit-autofill': {
						color: '#FFCCA5',
					},
				},
				invalid: {
					color: '#bf4336',
					iconColor: '#bf4336'
				}
			};

			let that = this;

			 // Floating labels
			  var inputs = document.querySelectorAll('#payment-form .InputElement');
			  Array.prototype.forEach.call(inputs, function(input) {
				  input.addEventListener('focus', function() {
					  input.classList.add('focused');
				  });
				  input.addEventListener('blur', function() {
					  input.classList.remove('focused');
				  });
				  input.addEventListener('keyup', function() {
					  if (input.value.length === 0) {
						  input.classList.add('empty');
					  } else {
						  input.classList.remove('empty');
					  }
				  });
			  });

			  var elementClasses = {
				 focus: 'focused',
				 empty: 'empty',
				 invalid: 'invalid',
			  };
			 // Create an instance of the card Element.
			if (!cardNumber) {
				 cardNumber = elements.create('cardNumber', {
					style: style,
					classes: elementClasses,
					placeholder: ''
				 });
			 }
			 cardNumber.mount('#card-element-card-number');

			 if (!cardExpiry) {
				 cardExpiry = elements.create('cardExpiry', {
					style: style,
					classes: elementClasses,
					placeholder: 'MM/YY'
				 });
			 }
			 cardExpiry.mount('#card-element-card-expiry');
			 if (!cardCvc) {
				 cardCvc = elements.create('cardCvc', {
					style: style,
					classes: elementClasses,
					placeholder: ''
				 });
			 }
			 cardCvc.mount('#card-element-card-cvc');

			 // registerElements([cardNumber, cardExpiry, cardCvc], 'card-element');

			// Add an instance of the card Element into the `card-element` <div>.
			// card.mount('#card-element');
			// Handle real-time validation errors from the card Element.
			cardNumber.addEventListener('change', function(event) {
			  var displayError = document.getElementById('card-errors');
			  if (event.brand) {
				 that.setBrandIcon(event.brand);
			  }
			  if (event.error) {
				 that.errorcard = {error: true, msg: event.error.message };
			  } else {
				 that.errorcard = {error: false, msg: '' };
			  }
			});
      that.stripeLoaded = true;
		},
		async setBrandIcon(brand) {
			var cardBrandToPfClass = {
			 'visa': 'pf-visa',
			  'mastercard': 'pf-mastercard',
			  'amex': 'pf-american-express',
			  'discover': 'pf-discover',
			  'diners': 'pf-diners',
			  'jcb': 'pf-jcb',
			  'unknown': 'pf-credit-card',
		  };
		   var brandIconElement = document.getElementById('brand-icon');
		   var pfClass = 'pf-credit-card';
		   if (brand in cardBrandToPfClass) {
		 	 pfClass = cardBrandToPfClass[brand];
		   }
		   for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
		 	 brandIconElement.classList.remove(brandIconElement.classList[i]);
		   }
		   brandIconElement.classList.add('pf');
		   brandIconElement.classList.add(pfClass);
	   },
    async reset() {
      this.isLoading = true;
      const reset = await api({endpoint: `${process.env.VUE_APP_API}/payments`, path: '/del', method: 'GET'});
      if (reset.stripe === true) {
        this.cards = [];
        this.hascard = false;
        this.isLoading = false;
      }
    },
    async sendCard() {
			let that = this;
      this.isLoading = true;
			this.loadingcard = true;
			this.errorcard = { error: false, msg: "" };
			const result = await stripe.createToken(cardNumber);
      if (result.error) {
        // Inform the user if there was an error.
        that.errorcard = { error: true, msg: result.error.message };
        that.loadingcard = false;
        that.isLoading = false;
        that.addcard = false;
        that.stepNext++;
        return false;
      } else {
        // Send the token to your server.
        if (result.token && result.token.card) {
        	const tokencard = result.token.id;
        	const newcard = await api({endpoint: `${process.env.VUE_APP_API}/payments/set-card/${tokencard}`, path: '', method: 'GET'});
        	if (newcard && newcard.return === true) {
        		that.cards[0] = result.token.card;
        		that.cards[0].cvc_check = 'pass';
        		that.hascard = true;
        		that.errorcard = {error: false, msg: ""};
        		that.loadingcard = false;
        		that.paymentMethodDialog = false;
            that.isLoading = false;
            that.addcard = false;
            that.stepNext++;
            await that.loadData();
            return true;
        	} else {
        		that.loadingcard = false;
        		that.paymentMethodDialog = false;
        		that.errorcard = {error: true, msg: newcard.msg ? newcard.msg : "Something went wrong adding your card, please try again, another one, or contact BestAgent team."};
            that.isLoading = false;
            that.addcard = false;
            that.stepNext++;
            return false;
        	}
        } else {
        	that.loadingcard = false;
        	that.paymentMethodDialog = false;
        	that.errorcard = {error: true, msg: "Please contact BestAgent team or try again later." };
          that.isLoading = false;
          that.addcard = false;
          that.stepNext++;
          return false;
        }
      }
		}
  }
};

</script>
<style>
.form-card {
  border: 1px solid #e7e7e7;
  background-color: #f9f9f9;
  padding:15px;
  margin:15px;
  min-width: 400px;
  width: 40%;
  margin-left: auto;
  margin-right: auto
}
input,
.StripeElement {
  height: 40px;
  padding: 10px 12px;

  color: #32325d;
  background-color: white;
  border: 1px solid transparent;
  border-radius: 4px;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

input:focus,
.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
